import { useRef, useState } from 'react';
import { alpha } from '@mui/material/styles';
import { Box, Typography, Avatar, IconButton, styled, MenuItem } from '@mui/material';
import MenuPopover from '../../../../components/MenuPopover';
import { useAuth } from '../../../../providers/authentication';
import LogoutIcon from '@mui/icons-material/Logout';
import AddIcon from '../../../../assets/images/add.png';
import { api } from '../../../../api';
import ConfirmModal from '../../../../components/modals/ConfirmModal';

const defaultPhotoURL =
  'https://minimal-kit-react.vercel.app/static/mock-images/avatars/avatar_default.jpg';

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const auth = useAuth();
  const anchorRef = useRef(null);
  const [isShowConfirmModal, setIsShowConfirmModal] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOnClickConfirm = () => {
    setOpen(false);
    setIsShowConfirmModal(false);
    auth?.signOut();
  };

  const navigateToUSAPortal = () => {
    api
      .get('/token/usa', {
        withCredentials: true
      })
      .then((res) => {
        const { data } = res;
        window.location.href = `https://usapor.pttplc.com/ship-desktop?token=${data.token}`;
      });
  };

  return (
    <>
      <Box sx={{ my: 1.5, px: 2.5, textAlign: 'right' }}>
        <Typography variant="subtitle2" noWrap>
          {auth?.user?.full_name ? auth.user.full_name : auth?.user?.user_name}
        </Typography>
        <Typography variant="caption" noWrap color="gray">
          {auth?.user?.role?.role_description?.toLocaleUpperCase()}
        </Typography>
      </Box>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8)
            }
          })
        }}
      >
        <Avatar
          src={auth?.user?.photo ? auth.user.photo : defaultPhotoURL}
          alt={auth?.user?.full_name ? auth.user.full_name : auth?.user?.user_name}
        />
      </IconButton>
      <MenuPopover
        open={Boolean(open)}
        anchorEl={anchorRef.current}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75
          }
        }}
      >
        {/* <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {auth?.user?.user_name}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} /> */}

        {/* <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} to={option.linkTo} component={Link} onClick={handleClose}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} /> */}
        <MenuItem sx={{ m: 1 }} onClick={navigateToUSAPortal}>
          <span
            style={{ textDecoration: 'none' }}
            // href="https://usapor.pttplc.com/ship-desktop?token="
          >
            <img style={{ width: 20, marginRight: 8 }} src={AddIcon} />
            PTT SHIP Portal
          </span>
        </MenuItem>
        <MenuItem sx={{ m: 1 }} onClick={() => setIsShowConfirmModal(true)}>
          <LogoutIcon sx={{ color: '#EF474A', marginRight: '5px' }} />
          Log out
        </MenuItem>
      </MenuPopover>
      <ConfirmModal
        title={'ยืนยัน'}
        contentText={'คุณต้องการที่จะออกจากระบบ ?'}
        open={isShowConfirmModal}
        onSubmit={() => handleOnClickConfirm()}
        onClose={() => setIsShowConfirmModal(false)}
      />
    </>
  );
}

const LogoutButton = styled(IconButton)(({ theme }) => ({
  color: 'white',
  borderRadius: 8,
  marginLeft: 8,
  backgroundColor: '#EF474A',
  '&:hover': {
    backgroundColor: theme.palette.error.dark
  }
}));
